import { IEventMetadata, IFormFieldMetadata, IFormFieldValueMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ITrial, ResponseStatus } from "@/api/dtos";
import { IConfigurationItem } from "@/utilities/forms/ConfigurationFormProcessor";
import { Observable } from "@ngt/forms-core";
import { createContext } from "react"

export interface IConfigurationFormEditContext<TConfigurationItem = IConfigurationItem> {
    item: TConfigurationItem;
    configurationPropertyPath: string;
    configurationLocalPropertyPath: string;
    configurationGlobalPropertyPath: string;
    configurationTrialPropertyPath: string;
    usingGlobalConfiguration: boolean;
    usingTrialConfiguration: boolean;
    link: () => boolean;
}

export const ConfigurationFormEditContext = createContext<Observable<IConfigurationFormEditContext | undefined>>(new Observable<IConfigurationFormEditContext | undefined>(undefined));

export default ConfigurationFormEditContext;